export const GET_SERVICE_RESTART_ERROR_CODES = {
  INIT: "GET_SERVICE_RESTART_ERROR_CODES_INIT",
  SUCCESS: "GET_SERVICE_RESTART_ERROR_CODES_SUCCESS",
  ERROR: "GET_SERVICE_RESTART_ERROR_CODES_ERROR",
};

export const GET_SERVICE_RESTART_LOGS = {
  INIT: "GET_SERVICE_RESTART_LOGS_INIT",
  SUCCESS: "GET_SERVICE_RESTART_LOGS_SUCCESS",
  ERROR: "GET_SERVICE_RESTART_LOGS_ERROR",
};
